module.exports = __webpack_public_path__ + "media/images/articles/resume/sec01_img_01-5d3668d890bf3ca2c76921ae7d208f0d.png";